import { Chip, Tooltip, Box, Typography, useTheme } from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";

import { formatDate } from "@aclymatepackages/formatters";

const buildTooltipContent = ({ lastBulkImportedAt, dataQualityNotes }) => (
  <Box>
    <Typography variant="subtitle2" color="textPrimary">
      Customer-uploaded estimate
    </Typography>
    <Typography variant="caption" color="textSecondary" display="block">
      This employee&apos;s data came from a customer-supplied spreadsheet rather than
      a self-completed survey. Emissions are calculated using conservative
      GHG-protocol defaults wherever detail is missing. For more accurate data,
      please have this employee take the survey.
    </Typography>
    {lastBulkImportedAt && (
      <Typography variant="caption" color="textSecondary" display="block">
        Last imported: {formatDate(lastBulkImportedAt)}
      </Typography>
    )}
    {!!dataQualityNotes?.length && (
      <Box mt={1}>
        <Typography variant="caption" color="textPrimary" display="block">
          Defaulted fields:
        </Typography>
        {dataQualityNotes.map((note, idx) => (
          <Typography
            key={`data-quality-note-${idx}`}
            variant="caption"
            color="textSecondary"
            display="block"
          >
            • {note}
          </Typography>
        ))}
      </Box>
    )}
  </Box>
);

const CustomerUploadedBadge = ({
  lastBulkImportedAt,
  dataQualityNotes = [],
  size = "small"
}) => {
  const { palette } = useTheme();

  return (
    <Tooltip
      title={buildTooltipContent({ lastBulkImportedAt, dataQualityNotes })}
    >
      <Chip
        icon={<InfoIcon />}
        label="Estimated"
        size={size}
        sx={{
          backgroundColor: palette.backgroundGray.main,
          color: palette.text.secondary,
          borderColor: palette.backgroundGray.dark
        }}
        variant="outlined"
      />
    </Tooltip>
  );
};

export default CustomerUploadedBadge;
